// ===============================================
// ACTIVE COMPONENTS
// ===============================================

export * from './ResourceForm';
export * from './ResourceDetail';
export * from './DeleteConfirmationDialog';
export * from './ValidatedField';

// Export specific interfaces and types needed by template components
export type { DetailSection, RelatedItem, ResourceDetailTab } from './ResourceDetail';
export type { FormSection, FormFieldConfig } from './ResourceForm';
